import { useState } from 'react';
import { inMemoryKVStore } from '../../../../../infra/persistence';
import { CREATOR_FILTER_KEY } from '../../types';
export var useCreatorFilter = function () {
    var _a = useState(inMemoryKVStore.getItem(CREATOR_FILTER_KEY) || []), creatorFilter = _a[0], setLocalCreatorFilter = _a[1];
    var setCreatorFilter = function (newCreatorFilter) {
        setLocalCreatorFilter(newCreatorFilter);
        inMemoryKVStore.setItem(CREATOR_FILTER_KEY, newCreatorFilter);
    };
    var filterByCreator = function (row) {
        var rowCampaign = row.original;
        return creatorFilter.includes(rowCampaign.ownerId);
    };
    return {
        creatorFilter: creatorFilter,
        setCreatorFilter: setCreatorFilter,
        filterByCreator: filterByCreator,
    };
};
